import invariant from 'fbjs/lib/invariant';
import * as extensionsSelectors from '../../store/slices/extensions/selectors.js';
import { loadExtension } from './loader.js';

/**
 * @typedef {Object} ExtensionDescription
 * @property {string} name
 * @property {*} options
 * @property {string} display_name
 * @property {string} src
 * @property {string} version
 */

/**
 * @typedef {Object} ExtensionDependencies
 * @property {Object} mns
 * @property {Object} accessors
 * @property {API} API
 * @property {Store<any, AnyAction>} store
 */

export default ExtensionRegistry;

/**
 * @param {Object} extensionDependencies
 * @param {import('redux').Store} extensionDependencies.store
 * @param extensionDependencies.mns
 * @param extensionDependencies.API
 * @param extensionDependencies.accessors
 * @return {{get(string): Extension|undefined, register(ExtensionDescription): void}|any}
 * @constructor
 */
function ExtensionRegistry({
  store,
  mns,
  API,
  accessors,
  renderersRegistry,
  configProvider,
}) {
  configProvider.subscribe((config) => {
    console.warn('TODO: handler extensions on configuration update, include very initial', config.extensions);
  });
  /**
   * Entry point for extension registration.
   * Every extension MUST expose self into this object with own name, e.g.:
   * @example
   * // webpack.config.js
   * output: {
   *   library: {
   *     name: `InteractiveExtension["${name}"]`,
   *     type: 'assign-properties',
   *     export: 'default',
   *   },
   * }
   *
   * @type {{}}
   */
  window.InteractiveExtension = window.InteractiveExtension || {};

  store.observers.add(
    extensionsSelectors.requiredToRegister,
    (extensionsList) => {
      extensionsList.forEach(register);
      renderersRegistry.update(store.getState().extensions);
    },
  );

  store.observers.add(extensionsSelectors.requiredToFetch, (extensionsList) => {
    extensionsList.map(loadExtension).forEach(store.dispatch);
  });
  const extensions = new Map();
  /**
   *
   * @type {ExtensionDependencies}
   */
  const dependencies = { store, mns, API, accessors };

  return {
    get(name) {
      return extensions.get(name);
    },
    register: register,
  };

  function register(extensionDescription) {
    const extImpl = window.InteractiveExtension[extensionDescription.name];

    try {
      invariant(
        extImpl,
        'Extension "%s" does not found.',
        extensionDescription.name,
      );
      const extension = new extImpl.Factory(extensionDescription, dependencies);

      extensions.set(extensionDescription.name, extension);
      renderersRegistry.register(extensionDescription.name, extension);
      store.dispatch({
        type: 'extensions/init/success',
        payload: {
          ...extensionDescription,
        },
      });
    } catch (error) {
      console.error(error);
      // debugger;
      store.dispatch({
        type: 'extensions/init/failure',
        payload: {
          ...extensionDescription,
        },
        meta: {
          error: error.toString(),
        },
      });
    }
  }
}
